<template>
  <section>
    <!-- Listing Header -->
    <habits-header :isThere="isThere" @search="search" @add="addHabit" />
    <!-- Listing -->
    <div class="custom-wrapper">
      <z-table
        :value="habits"
        :columns="tableColumns"
        :isSingleRowDetail="false"
        class="table table-bordered table-striped"
        detailColumnClass="z-column-60-center"
        @sort="setOrder"
        :loading="isLoading"
      >
        <template v-slot:tbody="props">
          <th scope="row" class="z-column-60-center">{{ props.row.id }}</th>
          <td class="z-column-60-center">
            <a href="#" @click="getHabit(props.row)">edit</a>
          </td>
          <td class="z-column-60-center">
            <div class="custom-icon">
              <img :src="getIcon(props.row.type)" height="32" width="32" />
            </div>
          </td>
          <td>{{ props.row.name }}</td>
          <td>
            {{ props.row.text }}
          </td>
          <td class="z-column-60-center">
            {{ formatAllow(props.row.allowTime) }}
          </td>
          <td>
            <button class="btn btn-link" @click="remove(props.row)">
              remove
            </button>
          </td>
        </template>
        <template v-slot:empty> Nothing found! </template>
      </z-table>
    </div>
    <habit-dialog
      id="habit-modal"
      :show="actionHabit"
      @close="closeHabit"
      @saved="savedHabit"
    />
    <confirm-remove
      :show="actionConfirmRemove"
      :confirmTitle="confirmTitleRemove"
      :confirmAction="confirmActionRemove"
      :confirmQuestion="confirmQuestionRemove"
      @closing="closeModal"
      @proceed="performRemove"
    />
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import ZTable from '@/Components/ZElements/Table'
import HabitsHeader from '@/Components/Nutrition/habits-header'
import HabitDialog from '@/Components/Nutrition/forms/habit-dialog'
import ConfirmRemove from '@/Components/ZElements/ConfirmDialog'
export default {
  name: 'habit-listing',
  components: {
    ZTable,
    HabitsHeader,
    HabitDialog,
    ConfirmRemove,
  },
  data() {
    return {
      page: 1,
      actionHabit: null,
      isLoading: false,
      confirmTitleRemove: 'Confirm Removal',
      confirmActionRemove: 'Remove',
      confirmQuestionRemove: 'Are you sure you wish to remove this Habit?',
      actionConfirmRemove: null,
      itemId: null,
    }
  },
  async mounted() {
    this.isLoading = false
    this.itemId = null
    this.setPager({
      name: 'page',
      value: 1,
    })
    this.setPager({
      name: 'search',
      value: '',
    })
    await this.getHabitIcons()
    await this.search()
  },
  computed: {
    ...mapGetters('organizations', ['examineOrganization']),
    ...mapGetters('nutrition', ['habits', 'habit', 'pager', 'habitIcons']),
    tableColumns() {
      return [
        {
          field: 'id',
          label: '',
          sortable: false,
          class: 'z-column-60-center',
        },
        {
          field: 'id',
          label: '',
          sortable: false,
          class: 'z-column-60-center',
        },
        {
          field: 'id',
          label: '',
          sortable: false,
          class: 'z-column-60-center',
        },
        { field: 'name', label: 'Name', sortable: true },
        {
          field: 'text',
          label: 'Description',
          sortable: false,
        },
        {
          field: 'allow_time',
          label: 'Track?',
          sortable: false,
          class: 'z-column-60-center',
        },
        {
          field: 'id',
          label: '',
          sortable: false,
          class: 'z-column-60-center',
        },
      ]
    },
    isThere() {
      let _is = false
      if (this.habits) {
        if (this.habits.length > 0) {
          _is = true
        }
      }
      return _is
    },
  },
  methods: {
    ...mapActions('nutrition', [
      'getHabitIcons',
      'getHabits',
      'editHabit',
      'resetHabit',
      'removeHabit',
      'setPager',
    ]),
    formatAllow(allow) {
      let is = ''
      if (allow) {
        is = 'Y'
      }
      return is
    },
    getIcon(type) {
      let url = null
      if (this.habitIcons) {
        let found = this.habitIcons.find(
          (x) => parseInt(x.Value) === parseInt(type)
        )
        if (found) {
          url = found.TextValue
        }
      }
      return url
    },
    async setOrder(column, order) {
      this.setPager({
        name: 'sortBy',
        value: column.field,
      })
      this.setPager({
        name: 'orderBy',
        value: order,
      })
      await this.search()
    },
    async search() {
      try {
        await this.getHabits({
          page: this.pager.page,
          pageSize: this.pager.pageSize,
          sortBy: this.pager.sortBy,
          orderBy: this.pager.orderBy,
          search: this.pager.search,
          orgId: this.examineOrganization.id,
        })
        window.app.$forceUpdate()
      } catch (e) {
        console.log('Error', e)
      }
    },
    closeHabit() {
      this.actionHabit = null
    },
    closeModal() {
      this.actionConfirmRemove = null
    },
    async savedHabit() {
      await this.search()
    },
    async addHabit() {
      let data = {
        id: null,
        name: null,
        orgId: this.examineOrganization.id,
      }
      this.resetHabit(data)
      this.actionHabit = {
        isAdd: true,
        data: null,
      }
    },
    remove(row) {
      this.itemId = row.id
      this.actionConfirmRemove = true
    },
    async performRemove() {
      this.actionConfirmRemove = null
      // Perform Removal
      await this.removeHabit(this.itemId)
      this.search()
      this.itemId = null
    },
    getHabit(row) {
      let data = {
        id: row.id,
        name: row.name,
        orgId: this.examineOrganization.id,
      }
      this.editHabit(data.id)
      this.actionHabit = {
        isAdd: false,
        data: data,
      }
    },
  },
}
</script>
<style lang='scss'>
.custom-wrapper {
  overflow-x: hidden;
  overflow-y: auto;
  position: relative;
}
.custom-add {
  position: absolute;
  top: 9px;
  left: 8px;
}
.custom-icon {
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  padding: 7px;
  border-radius: 5px;
  text-align: center;
}
</style>
